import Popover from 'antd/lib/popover';
import * as React from 'react';
import { antGrey } from '../styles/globalStyles';
import { AlignLeftOutlined } from '@ant-design/icons';
import MarkdownComponent from '../HOCs/Markdown';

const DESCRIPTION_FONT_SIZE = 12;
const DESCRIPTION_POPOVER_MAX_WIDTH = 360;
const DESCRIPTION_POPOVER_MAX_HEIGHT = 320;

export const DescriptionPopoverIcon: React.FC<{ description: string }> = ({ description }) => (
    <Popover
        content={
            <div
                className="metric-description-markdown"
                style={{
                    maxWidth: DESCRIPTION_POPOVER_MAX_WIDTH,
                    maxHeight: DESCRIPTION_POPOVER_MAX_HEIGHT,
                    overflowY: 'auto',
                }}
            >
                <MarkdownComponent source={description} style={{ fontSize: DESCRIPTION_FONT_SIZE }} />
            </div>
        }
    >
        <AlignLeftOutlined style={{ color: antGrey.grey7, fontSize: 10 }} />
    </Popover>
);
